import apiURLBuilder from '../core/apiURLBuilder';
import Api from '../services/api';
import actionTypes from 'constants/actionTypes';
import { getLanguage } from 'core/i18n';
import { goToErrorsView } from './errorViewNavigation';

let value;
const languaje = getLanguage();

const getCMS = (text, tooltip) => dispatch => {
    value = `${text},${tooltip}`;
    const saveRequestData = {
        header: {},
        query: {
            language: languaje,
            channel: 'onboarding',
            webContentId: value,
        },
    };

    const getCMSContentURL = apiURLBuilder.getURL('getCMSContent');

    return Api.get(getCMSContentURL, saveRequestData).then(response => {
        if (response.body.status !== 'Error') {
            const data = {};

            if (response.body.data.nodes.length) {
                response.body.data.nodes.map(value => {
                    if (value.field_location_id[0].value.includes('tooltip')) {
                        data.tooltip = value.body[0].value;
                    } else {
                        data.text = value.body[0].value;
                    }
                });

                if (text.includes('registro')) {
                    dispatch({
                        type: actionTypes.LOAD_CMS_REGISTER,
                        data,
                    });
                } else if (text.includes('additional')) {
                    dispatch({
                        type: actionTypes.LOAD_CMS_ADDITIONAL,
                        data,
                    });
                } else {
                    dispatch({
                        type: actionTypes.LOAD_CMS_POSTFIOC_APPROVED,
                        data,
                    });
                }
            }
        } else {
            dispatch(goToErrorsView({ errorCode: response.body.status, errorMessage: getCMSContentURL }));
        }
    });
};

const getCMSNotApproved = (text, tooltip, title) => dispatch => {
    value = `${text},${tooltip},${title}`;
    const saveRequestData = {
        header: {},
        query: {
            language: languaje,
            channel: 'onboarding',
            webContentId: value,
        },
    };

    const getCMSContentURL = apiURLBuilder.getURL('getCMSContent');

    return Api.get(getCMSContentURL, saveRequestData).then(response => {
        if (response.body.status !== 'Error') {
            const data = {};

            if (response.body.data.nodes.length) {
                response.body.data.nodes.map(value => {
                    if (value.field_location_id[0].value.includes('tooltip')) {
                        data.tooltip = value.body[0].value;
                    } else if (value.field_location_id[0].value.includes('text')) {
                        data.text = value.body[0].value;
                    } else {
                        data.title = value.body[0].value;
                    }
                });

                dispatch({
                    type: actionTypes.LOAD_CMS_POSTFIOC_NOT_APPROVED,
                    data,
                });
            }
        } else {
            dispatch(goToErrorsView({ errorCode: response.body.status, errorMessage: getCMSContentURL }));
        }
    });
};

const getCMSStandby = listItem => dispatch => {
    const saveRequestData = {
        header: {},
        query: {
            language: languaje,
            channel: 'onboarding',
            webContentId: listItem,
        },
    };
    const getCMSContentURL = apiURLBuilder.getURL('getCMSContent');

    return Api.get(getCMSContentURL, saveRequestData).then(response => {
        if (response.body.status !== 'Error') {
            const data = {};

            if (response.body.data.nodes.length) {
                data.text = response.body.data.nodes[0].body[0].value;
            }

            dispatch({
                type: actionTypes.LOAD_CMS_STAND_BY,
                data,
            });
        } else {
            dispatch(goToErrorsView({ errorCode: response.body.status, errorMessage: getCMSContentURL }));
        }
    });
};

export default {
    getCMS,
    getCMSNotApproved,
    getCMSStandby,
};
